<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header">
    <mat-card-title class="mcd-card-title">Run Links Analysis </mat-card-title>
  </mat-card-header>
  <div class="mat-card-wrapper">
    <mat-card-content class="mcd-card-content">
      <div class="mcd-edit-form mcd-grbes-form">
        <div class="row">
          <div class="col-3"></div>
          <div class="col-6">
            <div class="list-group">
              <button  class="list-group-item list-group-item-action" [disabled]="run_script" (click)="runscript(dynamicEmail)"
               >
                Run Script
              </button>
              <button  class="list-group-item list-group-item-action" [disabled]="view_script" (click)="openHtmlFile()"
                >View
                Report</button>
               <!-- <iframe *ngIf="showFrame" [src]="htmlFilePath" width="500" height="300"></iframe> -->
            </div>
            <div class="col-3"></div>
          </div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-footer class="mcd-card-footer">
    </mat-card-footer>
  </div>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>
